<template>
  <div class="report-analytic-section-container">
    <div class="section-header">
      <div class="header-title">
        <mf-icon color="marca-0-l20" size="20" :fill="headerConfiguration.fillIcon">{{ headerConfiguration.icon }}</mf-icon>
        <span>{{ headerConfiguration.title }}</span>
      </div>
      <div class="line-divider"></div>
      <div class="header-recurrent-analytics" :class="{ 'limit-reached': isLimitReached('recurrent') }">
        <mf-icon color="cinza-d10" size="20" fill>source_notes</mf-icon>
        <span class="quantity">{{ `${limits.recurrent.createdTotal}/${limits.recurrent.limitTotal}` }}</span>
        <span class="label">Análises recorrentes</span>
      </div>
      <div class="header-not-recurrent-analytics" :class="{ 'limit-reached': isLimitReached('notRecurrent') }">
        <mf-icon color="cinza-d10" size="20">article</mf-icon>
        <span class="quantity">{{ `${limits.notRecurrent.createdTotal}/${limits.notRecurrent.limitTotal}` }}</span>
        <span class="label">Análises isoladas</span>
      </div>
    </div>
    <div class="section-table">
      <report-analytic-table :recurrent-analytics="recurrentAnalytics" :not-recurrent-analytics="notRecurrentAnalytics" :type="type" />
    </div>
  </div>
</template>

<script>
import ReportAnalyticTable from './ReportAnalyticTable.vue'

export default {
  name: 'ReportAnalyticSection',
  components: { ReportAnalyticTable },
  props: {
    type: {
      type: String,
      default: 'rfv',
      validator: (value) => ['rfv', 'dre'].includes(value),
    },
    recurrentAnalytics: {
      type: Array,
      default: () => [],
    },
    notRecurrentAnalytics: {
      type: Array,
      default: () => [],
    },
    limits: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  computed: {
    headerConfiguration() {
      const rfvConfiguration = {
        title: 'Classificação RFV',
        icon: 'groups',
        fillIcon: true,
      }
      const dreConfiguration = {
        title: 'Faturamento incremental',
        icon: 'payments',
        fillIcon: false,
      }
      return this.type === 'rfv' ? rfvConfiguration : dreConfiguration
    },
  },
  methods: {
    isLimitReached(model) {
      const limit = this.limits[model]

      return limit?.createdTotal === limit?.limitTotal
    },
  },
}
</script>

<style lang="scss" scoped>
.report-analytic-section-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .section-header {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-content: center;

    .header-title {
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-content: center;
      span {
        color: $marca-0-l20;
        font-size: 16px;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: 0.16px;
      }
    }
    .line-divider {
      background: #a5acb4;
      width: 1px;
      height: 24px;
    }
    .header-recurrent-analytics,
    .header-not-recurrent-analytics {
      display: flex;
      flex-direction: row;
      gap: 4px;
      align-content: center;
      font-size: 14px;
      line-height: 142%;
      color: $cinza-d10;
      .quantity {
        font-weight: 700;
      }
      .label {
        font-weight: 400;
      }
    }
  }
}
.limit-reached {
  span {
    color: $vermelho-d20 !important;
  }
}
</style>
